var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[_vm._t("spinner",[(_vm.displaySpinner)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"pct"},[_vm._v(" "+_vm._s(_vm.Images.progress)+"% ")]),_c('div',{staticClass:"border"})]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }